import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Floor  {
    _originalTypeClassName = "zERP.BO.Floor";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Floor.translate = translateService;
}
this.DepartmentFloors = [];
this.Id = null;
this.Name = null;
this.Number = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Number:any;
Notes:any;
Location:any;
DepartmentFloors:any;
static setLocation = ($this, value) => {
var oldValue = $this.Location;
$this.Location = value;
if (value != null) {
if (oldValue != null) {
Domain.Location.removeFloors(oldValue, $this);
}
Domain.Location.addFloors(value, $this);
}
}
static setDepartmentFloors = ($this, items) => {
                if (items == null) items = [];
                if ($this.DepartmentFloors == null) $this.DepartmentFloors = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DepartmentFloors.length > 0) {
                    Domain.Floor.removeDepartmentFloors($this, $this.DepartmentFloors[0]);
                }

                Domain.Floor.addManyDepartmentFloors($this, copyItems);
            }
static addManyDepartmentFloors = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Floor.addDepartmentFloors($this, items[i]);
                }
            }
static addDepartmentFloors = ($this, item) => {
                if ($this.DepartmentFloors == null) $this.DepartmentFloors = [];
                if (item == null || $this.DepartmentFloors.indexOf(item) > -1) return;
                $this.DepartmentFloors.push(item);
if (item.Floor != $this) {
Domain.DepartmentFloor.setFloor(item, $this);
}
}
static addRangeDepartmentFloors = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Floor.addDepartmentFloors($this, item));
            }
static removeDepartmentFloors = ($this, item) => {
                if ($this == null || $this.DepartmentFloors == null || $this.DepartmentFloors.indexOf(item) === -1) return;
                var _index = $this.DepartmentFloors.indexOf(item);
                $this.DepartmentFloors.splice(_index, 1);
item.Floor = null;
}
static clearDepartmentFloors = ($this) => { $this.DepartmentFloors = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}